/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceQuoteTemplateLineResource } from './';
import {
    FixedPriceQuoteTemplateLineResourceFromJSON,
    FixedPriceQuoteTemplateLineResourceFromJSONTyped,
    FixedPriceQuoteTemplateLineResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceQuoteTemplateDetailsResource
 */
export interface FixedPriceQuoteTemplateDetailsResource {
    /**
     * 
     * @type {Array<FixedPriceQuoteTemplateLineResource>}
     * @memberof FixedPriceQuoteTemplateDetailsResource
     */
    quoteLines?: Array<FixedPriceQuoteTemplateLineResource>;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceQuoteTemplateDetailsResource
     */
    additionalNotes?: string;
}

/**
 * Check if a given object implements the FixedPriceQuoteTemplateDetailsResource interface.
 */
export function instanceOfFixedPriceQuoteTemplateDetailsResource(value: object): value is FixedPriceQuoteTemplateDetailsResource {
    return true;
}

export function FixedPriceQuoteTemplateDetailsResourceFromJSON(json: any): FixedPriceQuoteTemplateDetailsResource {
    return FixedPriceQuoteTemplateDetailsResourceFromJSONTyped(json, false);
}

export function FixedPriceQuoteTemplateDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteTemplateDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteLines': json['quoteLines'] == null ? undefined : ((json['quoteLines'] as Array<any>).map(FixedPriceQuoteTemplateLineResourceFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
    };
}

export function FixedPriceQuoteTemplateDetailsResourceToJSON(value?: FixedPriceQuoteTemplateDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteLines': value['quoteLines'] == null ? undefined : ((value['quoteLines'] as Array<any>).map((v) => FixedPriceQuoteTemplateLineResourceToJSON(v))),
        'additionalNotes': value['additionalNotes'],
    };
}

